import React, { FC, ComponentProps } from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
  text-decoration: none;
  display: inline-block;
`;

type NewTabLinkProps = ComponentProps<typeof StyledLink> & {
  children: React.ReactNode;
};

export const NewTabLink: FC<NewTabLinkProps> = ({ children, ...props }) => {
  return (
    <StyledLink {...props} target="_blank" rel="noopener noreferrer">
      {children}
    </StyledLink>
  );
};
